import React, { useState } from "react";
import {
  Box, Paper, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField, Grid, Alert,
  CircularProgress, Card, CardContent
} from "@mui/material";
import { TrendingUp, TrendingDown, SwapHoriz, Refresh } from "@mui/icons-material";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function FlujoCaja() {
  const [loading, setLoading] = useState(false);
  const now = new Date();
  const [fechaInicio, setFechaInicio] = useState(new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split("T")[0]);
  const [fechaFin, setFechaFin] = useState(now.toISOString().split("T")[0]);
  const [flujo, setFlujo] = useState(null);

  const h = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });
  const fmt = (n) => parseFloat(n || 0).toLocaleString("es-EC", { style: "currency", currency: "USD" });

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/tesoreria/flujo-caja?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`, { headers: h() });
      setFlujo(res.data.data);
    } catch (e) {
      console.error("Error:", e);
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>Flujo de Caja</Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth size="small" type="date" label="Desde" value={fechaInicio}
              onChange={e => setFechaInicio(e.target.value)} InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth size="small" type="date" label="Hasta" value={fechaFin}
              onChange={e => setFechaFin(e.target.value)} InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button variant="contained" startIcon={<Refresh />} onClick={cargar} fullWidth sx={{ height: 40 }}>
              Generar
            </Button>
          </Grid>
        </Grid>

        {loading && <Box sx={{ textAlign: "center", py: 4 }}><CircularProgress /></Box>}

        {flujo && !loading && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Card sx={{ bgcolor: "success.light" }}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <TrendingUp /> <Typography variant="subtitle1">Ingresos</Typography>
                  </Box>
                  <Typography variant="h4" color="success.dark">{fmt(flujo.ingresos)}</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ bgcolor: "error.light" }}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <TrendingDown /> <Typography variant="subtitle1">Egresos</Typography>
                  </Box>
                  <Typography variant="h4" color="error.dark">{fmt(flujo.egresos)}</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ bgcolor: flujo.flujo_neto >= 0 ? "info.light" : "warning.light" }}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <SwapHoriz /> <Typography variant="subtitle1">Flujo Neto</Typography>
                  </Box>
                  <Typography variant="h4">{fmt(flujo.flujo_neto)}</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                      <TableCell><strong>Concepto</strong></TableCell>
                      <TableCell align="right"><strong>Monto</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow><TableCell>Saldo en Cajas</TableCell><TableCell align="right">{fmt(flujo.saldo_cajas)}</TableCell></TableRow>
                    <TableRow><TableCell>Saldo en Bancos</TableCell><TableCell align="right">{fmt(flujo.saldo_bancos)}</TableCell></TableRow>
                    <TableRow sx={{ bgcolor: "#e3f2fd" }}>
                      <TableCell><strong>Saldo Total Disponible</strong></TableCell>
                      <TableCell align="right"><strong>{fmt(flujo.saldo_total)}</strong></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}

        {!flujo && !loading && (
          <Alert severity="info">Seleccione un rango de fechas y haga clic en "Generar" para ver el flujo de caja.</Alert>
        )}
      </Paper>
    </Box>
  );
}
